import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import adyenUtils from 'adyenthreeds2-js-utils/dist/threeds2-js-utils';
import { isProduction } from '../../../lib/isEnv';

export type Psd2Params = ReturnType<typeof usePsd2Params>;

export const usePsd2Params = () => {
  const location = useLocation();

  return useMemo(
    () => ({
      browser_info: adyenUtils.getBrowserInfo(),
      device_channel: 'browser',
      psd2_enabled: true,
      redirect_shopper_url:
        typeof window === 'undefined' ? location.pathname : window.location.href.split('?')[0],
      psd2_test_case_amount: isProduction() ? undefined : 1
    }),
    [location]
  );
};
